// src/views/auth/SignIn.js
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import API_BASE_URL from "config/api";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE_URL}/api/users/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("access_token", data.access);
        localStorage.setItem("refresh_token", data.refresh);
        navigate("/admin/default");
      } else {
        const err = await res.json();
        setError(err.error || "Login failed. Please try again.");
      }
    } catch {
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-950">
      <div className="w-full max-w-sm bg-neutral-900 border border-neutral-800 rounded-2xl p-6 shadow-xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-semibold text-white">
            Login to your account
          </h2>
          <Link
            to="/sign-up"
            className="text-sm text-neutral-400 hover:text-white"
          >
            Sign Up
          </Link>
        </div>

        <p className="text-sm text-neutral-500 mb-6">
          Enter your email below to login to your account
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* 이메일 */}
          <div>
            <label className="block text-sm font-medium text-neutral-300 mb-1">
              Email
            </label>
            <input
              type="email"
              required
              // placeholder="team@chisquare.io"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-neutral-950 border border-neutral-800 text-neutral-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-neutral-700"
            />
          </div>

          {/* 비밀번호 */}
          <div>
            <label className="block text-sm font-medium text-neutral-300 mb-1">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-neutral-950 border border-neutral-800 text-neutral-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-neutral-700"
            />
            <Link
              to="/auth/forgot-password"
              className="block mt-2 text-xs text-neutral-500 hover:text-white text-right"
            >
              Forgot your password?
            </Link>
          </div>

          {error && (
            <p className="text-sm text-red-500 mt-2">{error}</p>
          )}

          {/* 로그인 버튼 */}
          <button
            type="submit"
            className="w-full bg-neutral-200 text-neutral-900 font-medium py-2 rounded-md hover:bg-white transition"
          >
            Login
          </button>

          {/* Google 로그인 */}
          <button
            type="button"
            className="w-full border border-neutral-700 text-neutral-300 font-medium py-2 rounded-md flex items-center justify-center gap-2 hover:bg-neutral-800 transition"
          >
            <FcGoogle className="text-lg" />
            Login with Google
          </button>
        </form>
      </div>
    </div>
  );
}